import React, { Component } from 'react';
import {Button, Col} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import Icon from '../../../../components/Icon';
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ D: 'DEFAULT' }, countriesObj);

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.cpc) {
            const { cpc } = this.props;

            this.state = {
                country: cpc.country,
                cpc: cpc.cpc,
                update: true
            };
        }
        else this.state = { country: '',  cpc: '' };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(this.state.country, this.state.cpc);
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <SelectWrap
                        values={countriesOptions}
                        label="Country:"
                        name="country"
                        onChange={this.handleFieldChange}
                        value={this.state.country}
                    />
                    <FieldGroup
                        type="number"
                        step={'0.00001'}
                        name="cpc"
                        label="Cpc:"
                        onChange={this.handleFieldChange}
                        value={this.state.cpc}
                        required
                    />
                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDefaultOffersCpc/components/Form/index.js